// extracted by mini-css-extract-plugin
module.exports = {"container":"i_aC","item":"i_aD","left":"i_aE","right":"i_aF","wording":"i_aG","icon":"i_aH","label":"i_aI","value":"i_aJ"};